require("./bootstrap");

// efectos de entrada
// import AOS from "aos";
// import "aos/dist/aos.css";

/*let $loading = document.querySelector("#loading");
$loading.classList.add("cargado");
setTimeout(() => {
    $loading.parentElement.removeChild($loading);
}, 500);*/

require("./menu.js");

$("#loading").fadeOut();
$(document).ready(function () {
    $(".up").on("click", function (e) {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: 0,
            },
            1000
        );
    });

    $(".scroll-to").click(function (e) {
        e.preventDefault();
        let target_id = "";
        if ($(this).data("scroll_to")) {
            target_id = $(this).data("scroll_to");
        } else {
            target_id = $(this).attr("href");
        }
        const $toElement = $(target_id);

        let alto_cabecera = 80;

        if ($toElement.length) {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $toElement.offset().top - alto_cabecera,
                },
                1000
            );
        }

        return false;
    });

    $(window).scroll(function () {
        let scrollTop = $(this).scrollTop();

        if (scrollTop > 5) {
            $("header").addClass("scroll");
            $("body").addClass("scroll");
        } else {
            $("header").removeClass("scroll");
            $("body").removeClass("scroll");
        }
    });

    function isEmptySelect(select) {
        const $select = $(select);
        if ($select.val() == "") {
            $select.parent(".form-floating").addClass("empty");
        } else {
            $select.parent(".form-floating").removeClass("empty");
        }
    }

    $("#formulario-buscador")
        .find("select")
        .on("change", function () {
            isEmptySelect($(this));
        });

    $.each($("#formulario-buscador").find("select"), function (index, $select) {
        isEmptySelect($select);
    });
    // AOS.init();

    $(".formulario-buscador").on("submit", function (e) {
        e.preventDefault();
        let url = $(this).attr("action");
        const ciudad = $(this).find("select[name=ciudad]").val();
        const tipo = $(this).find("select[name=tipologia]").val();
        url = `${url}/${ciudad}/${tipo}/regiones-todas`;
        console.log(url);
        document.location = url;
    });

    /* $(".busca-proyecto_inferior").on("click", function (e) {
        e.preventDefault();
        const ciudad = $("#select_ciudad_inferior").val();
        const tipo = $("#select_tipo_inferior").val();
        let url = $(this).attr("href");
        url = `${url}/${ciudad}/${tipo}/regiones-todas`;
        document.location = url;
    }); */

    $('#modal-banco-estado').show();
    $('#close-modal-banco-estado').on('click', function () {
        $('#modal-banco-estado').hide();
    });

    $('#modal-promocional-link').on('click', function () {
            $('#modal-promociones').hide();
    });
});


